import {getConfigValue} from '../utils/configUtils';
import {Config} from '../types';

export const useConfigValue = <Key extends keyof Config>(key: Key) => {
  return getConfigValue(key);
};
